import React from "react";

// App-level error boundary so a single render error can never blank the whole site.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error boundary caught", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-cream-light text-ink flex items-center justify-center px-6">
        <div className="max-w-lg text-center">
          <div className="overline mb-4 text-copper">Something went wrong</div>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight leading-tight mb-4">
            We hit a snag rendering this page.
          </h1>
          <p className="text-ink/70 leading-relaxed mb-8">
            The rest of the site is fine. Reload to try again, or head back to the homepage.
          </p>
          <div className="flex items-center justify-center gap-4">
            <button onClick={this.handleReload} className="btn-copper">
              Reload page
            </button>
            <a href="/" className="text-[12px] tracking-[0.18em] uppercase text-ink/70 hover:text-copper">
              Back to home
            </a>
          </div>
        </div>
      </div>
    );
  }
}
